import { Helmet } from "react-helmet";
import {
  fingerprintIframeUrl,
  fingerprintScriptUrl,
} from "../../lib/deviceFingerprint";

interface Props {
  /** merchantID + identificador. Vacío = no renderiza nada. */
  sessionId?: string;
}

/**
 * Tag de Device Fingerprint de CyberSource: el `<script>` va al `<head>` vía
 * Helmet y el `<noscript>` cae en el `<body>` por ser JSX de un componente
 * montado. Del ejemplo del doc solo se traduce el orden.
 *
 * Montarlo lo antes posible en el checkout, antes de cualquier early return por
 * loading: el profiling tarda segundos y debe correr antes de enviar la orden.
 */
const DeviceFingerprint = ({ sessionId }: Props) => {
  if (!sessionId) return null;

  return (
    <>
      <Helmet>
        <script type="text/javascript" src={fingerprintScriptUrl(sessionId)} />
      </Helmet>

      {/*
        El doc prohíbe este iframe en el <head> (viola W3C), por eso va acá.

        `dangerouslySetInnerHTML` y no un <iframe> hijo: React lo crearía como
        nodo DOM real y el navegador lo cargaría aunque JS esté habilitado,
        disparando un segundo profiling. Así queda inerte.

        En esta SPA (CSR) el noscript no aporta cobertura real —sin JS no hay
        React ni checkout—; se incluye por el doc y para cuando migre a la Next.
      */}
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe style="width:100px;height:100px;border:0;position:absolute;top:-5000px;" src="${fingerprintIframeUrl(
            sessionId
          )}"></iframe>`,
        }}
      />
    </>
  );
};

export default DeviceFingerprint;
